<template>
    <v-layout class="speaker-admin-layout">
        <v-flex
            mt-3
            class="speaker-resource"
            v-if="!ypoSpeaker">
            <v-layout row wrap>
                <v-flex md3 xs12>
                    <v-card class="panelBlock">
                        <v-flex tag="h2">{{SpeakerApplicants.SPEAKER_ADMINISTRATION}}</v-flex>
                        <v-flex class="speaker-resource__options">
                            <v-flex class="speaker-resource__options__row" @click="isShowApplicant(SpeakerApplicants.PENDING)"><i class="fas fa-user-clock"></i>{{SpeakerApplicants.PENDING_APPLICANTS}}</v-flex>
                            <v-flex class="speaker-resource__options__row" @click="isShowApplicant(SpeakerApplicants.REVIEWED)"><i class="fas fa-user-check"></i>{{SpeakerApplicants.REVIEWED_APPLICANTS}}</v-flex>
                            <v-flex class="speaker-resource__options__row" @click="isShowApplicant(SpeakerApplicants.YPO_SPEAKERS)"><i data-v-709eaf5c="" class="fas fa-search"></i> {{SpeakerApplicants.SEARCH_VIEW_SPEAKER_DIRECTORY}}</v-flex>
                        </v-flex>
                    </v-card>
                </v-flex>
                <v-flex
                    md9
                    xs12
                    pl-3
                    class="speaker-applicants-xs">
                    <v-flex class="speaker-resource__applicants" v-if="pendingApplicant">
                        <PendingApplicants></PendingApplicants>
                    </v-flex>
                    <v-flex class="speaker-resource__applicants" v-if="reviewedApplicant">
                        <ReviewedApplicants></ReviewedApplicants>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex class="speaker-resource__applicants" v-if="ypoSpeaker">
            <SearchSpeakers></SearchSpeakers>
        </v-flex>
    </v-layout>
</template>

<script>
    import PendingApplicants from './SpeakerPendingApplicants';
    import ReviewedApplicants from './SpeakerReviewedApplicants';
    import { SpeakerApplicants } from "../Speakers/speakerConstant";
    import SearchSpeakers from "../ResourceDirectory/SearchSpeakers";
    import { mapMutations } from 'vuex';
    import { storeMutation } from "../../store/storeMutations.constant";

    export default {
        name: "SpeakerAdministration",
        data: () => ({
            pendingApplicant: true,
            reviewedApplicant: false,
            ypoSpeaker: false,
            SpeakerApplicants,
        }),
        created() {
            // this.isShowApplicant(SpeakerApplicants.PENDING);
            this.isShowApplicant(this.$route.query.pendingApplicants ? SpeakerApplicants.PENDING : SpeakerApplicants.REVIEWED);
        },
        components: {
            PendingApplicants,
            ReviewedApplicants,
            SearchSpeakers,
        },
        methods: {

            ...mapMutations({
                setPrevRouteUrlName: `speaker/${storeMutation.setPrevRouteUrlName}`,
            }),
            isShowApplicant(type) {
                if (type === SpeakerApplicants.PENDING) {
                    this.$router.push({
                        path: '/speakerPage/speakerAdministration',
                        query: {
                            pendingApplicants: true,
                        },
                    });

                    this.pendingApplicant = true;
                    this.reviewedApplicant = false;
                    this.searchSpeaker = false;
                } else if (type === SpeakerApplicants.REVIEWED) {
                    this.$router.push({
                        path: '/speakerPage/speakerAdministration',
                        query: {
                            reviewedApplicants: true,
                        },
                    });
                    this.pendingApplicant = false;
                    this.reviewedApplicant = true;
                    this.searchSpeaker = false;
                } else {
                    this.$router.push({
                        path: '/speakerPage/searchSpeakers',
                    });
                }
            },

        },

    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .speaker-admin-layout {
        padding: 10px 60px;

        @include breakpoint(lg) {
            padding: 10px 30px;
        }

        @include breakpoint(md) {
            padding: 10px;
        }
    }

    .speaker-resource {
        &__options {
            &__row {
                border-bottom: 1px solid rgba($ypo-gray, 0.4);
                padding: 15px;
                position: relative;
                color: $ypo-blue;
                cursor: pointer;
                transition: all .3s ease;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                }

                &:hover {
                    background: rgba($ypo-gray, 0.1);
                    text-shadow: 0 1px $ypo-blue;
                }
            }
        }

        &__applicants {
            min-height: 400px;

            &__header {
                padding: 15px 0;
                border-bottom: 1px solid rgba($ypo-gray, 0.4);
                align-items: center;
                color: $ypo-blue;

                h2 {
                    font-family: 'Raleway', sans-serif;
                    font-size: 18px;
                    font-weight: 500;
                }

                span {
                    font-size: 14px;
                }
            }
        }
    }
</style>
